import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './FlussoPersonalizzazioneNotaValue.module.sass'


interface Props {
  value?: string
  placeholder?: string
  variant?: 'default' | 'accent' | 'warning'
  className?: string
}

const FlussoPersonalizzazioneNotaValue = (props: Props) => {

  const { 
    value,
    placeholder,
    variant = 'default',
    className = '',
  } = props

  return (
    <div className={cn(styles.root, value ? '' : styles['root--empty'], styles[`root--${variant}`], className)}>
      {value ? value : placeholder}
    </div>
  )
}

export default FlussoPersonalizzazioneNotaValue
